import React, { useEffect, useState } from 'react'
import { useDeleteOrderedProductMutation, useGetMovementsQuery } from '../../store/api/movementApi'
import DataTable from 'react-data-table-component'
import { Tooltip } from 'react-tooltip';
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2';

export default function Movement() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [genId, setGenId] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  // --
  const [movements, setMovement] = useState([])
  const [open, setOpen] = useState(false);

  const [openIndex, setOpenIndex] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);

  const { data, error, isLoading } = useGetMovementsQuery({
    refetchOnMountOrArgChange: false
  })

  const [deleteOrderedProduct] = useDeleteOrderedProductMutation()


  useEffect(() => {
    if (data) {
      setMovement(data)
    }
  }, [data])

  useEffect(() => {
    const filterData = () => {
      let filtered = movements;

      // Filter by date range
      if (startDate && endDate) {
        filtered = filtered.filter(item => item[0]?.actionDate >= startDate && item[0]?.actionDate <= endDate);
      }

      // Filter by genId
      if (genId) {
        filtered = filtered.filter(item => item[0]?.genId.toLowerCase().includes(genId.toLowerCase()));
      }

      setFilteredData(filtered);
    };

    filterData();
  }, [startDate, endDate, genId, movements]);






  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="color-text fs-4">Loading...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="row">
          <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border">
            <h3 className="text-danger">Opps!!!</h3>
            <span className="fs-4">
              <span className="text-danger"> An Error has occurred</span>
            </span>
            <div className="fs-5"> The server is shut down 😢</div>
          </div>
        </div>
      </div>
    )
  }

  const formatPurpose = (purpose) => {
    const words = purpose.split(' ');
    const maxLength = 10;
    let formattedPurpose = '';

    for (let i = 0; i < words.length; i++) {
      formattedPurpose += words[i] + ' ';
      if ((i + 1) % maxLength === 0) {
        formattedPurpose += '\n';
      }
    }

    return formattedPurpose.trim();
  };

  const showData = (index) => {
    setOpenIndex(index);
    setOpen(!open);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    const totalPages = Math.ceil(movements.length / newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page

    // If the current page is greater than the new total pages, set current page to the last page
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  };


  const handleDelete = (value) => {

    console.log(value);

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this order details !!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteOrderedProduct(value).then((done) => {
          if (done?.data.status === 200) {

            Swal.fire({
              title: 'Success!',
              text: done.data.message,
              icon: 'success',
              confirmButtonText: 'Done'
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: done.data.message,
              icon: 'error',
              confirmButtonText: 'Close'
            })
          }
        })
      }
    })
  }


  // const _columns = [
  //   //{ name: 'Id', selector: (row) => row.id, sortable: true, center: true },
  //   { name: 'Invoice ID', selector: (row) => row.genId, sortable: true, center: true },
  //   {
  //     name: 'Name',
  //     selector: (row) => row.name,
  //     sortable: true,
  //     center: true
  //   },
  //   {
  //     name: 'Quantity',
  //     selector: (row) => row.qty,
  //     sortable: true,
  //     center: true
  //   },
  //   {
  //     name: 'Type',
  //     selector: (row) => row.type,
  //     cell: (row) =>
  //       row.type === 'returning' ? (
  //         <div class="px-3 pe-3 p-2 rounded-5 bg-info opacity-75  text-center text-white  text-capitalize">{row.type}</div>
  //       ) : (
  //         <span className="px-3 pe-3 p-2 rounded-5 bg-success opacity-50  text-center text-white  text-capitalize">
  //           {row.type}
  //         </span>
  //       ),
  //     sortable: true,
  //     center: true
  //   },

  //   // {
  //   //   name: 'Purpose',
  //   //   selector: (row) => (
  //   //     <>
  //   //       <Link
  //   //         data-tooltip-id={`purposeTooltip-${row.id}`}
  //   //         data-tooltip-content={formatPurpose(row.purpose)}
  //   //         className="d-inline-block d-flex align-items-center text-decoration-none text-dark"
  //   //       >
  //   //         {row.purpose.slice(0, 15)}
  //   //       </Link>
  //   //       <Tooltip
  //   //         id={`purposeTooltip-${row.id}`}
  //   //         place="top"
  //   //         effect="solid"
  //   //         delayShow={200}
  //   //         style={{ whiteSpace: 'pre-wrap' }}
  //   //       />
  //   //     </>
  //   //   ),
  //   //   sortable: true,
  //   //   center: true
  //   // },


  //   // {
  //   //   name: 'Consumer',
  //   //   selector: (row) => row.actionDoer,
  //   //   sortable: true,
  //   //   center: true
  //   // },
  //   // {
  //   //   name: 'Category',
  //   //   selector: (row) => row.category,
  //   //   sortable: true,
  //   //   center: true
  //   // },
  //   {
  //     name: 'Create At',
  //     selector: (row) => row.actionDate,
  //     sortable: true,
  //     center: true
  //   }

  // ]

  const getRequestDate = (date) => {
    const [year, month, day] = date.split('-').map(Number);
    const dt = new Date(year, month - 1, day);
    return dt.toDateString();
  };


  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleGenIdChange = (e) => {
    setGenId(e.target.value);
  };




  return (
    <>
      <div className="block-content block-content-full">
        <h2 className="content-heading text-uppercase">Stock movements </h2>
      </div>
      <div className="block1">
        <div className="block-content block-content-full">
          <div className="row">
            <div className="col-md-4 mb-3">
              <label htmlFor="startDate" className="form-label">Start Date</label>
              <input style={{ height: '45px' }} type="date" className="form-control" id="startDate" value={startDate} onChange={handleStartDateChange} />
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="endDate" className="form-label">End Date</label>
              <input style={{ height: '45px' }} type="date" className="form-control" id="endDate" value={endDate} onChange={handleEndDateChange} />
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="genId" className="form-label">Invoice ID</label>
              <input style={{ height: '45px' }} type="text" className="form-control" id="genId" value={genId} onChange={handleGenIdChange} />
            </div>
          </div>
          <div className="row text-white p-2 pb-0 border-0 mx-1 mb-0" style={{ backgroundColor: '#01574E' }}>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='mx-xl-5'>Invoice Id</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='mx-xl-5'>Supplier</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='mx-xl-5'>Category</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='text-center mx-3'>Date</h6>
            </div>
          </div>
          <div>
            {
              currentItems.map((list, index) => {

                return <div className="card mt-3">
                  <div className="card-header">
                    <div class="row" >
                      <div class="col-md-12 col-lg-2 col-sm-12 col-xl-2 col-12">
                        <div className='d-flex justify-content-start'>
                          <button
                            className="btn btn-link bg-"
                            onClick={(e) => showData(index)}
                            aria-controls="example-collapse-text"
                            aria-expanded={open}
                          >
                            {open && index === openIndex ? <span>&#9660;</span> : <span>&#9650;</span>}
                          </button>
                          <h6 className='mt-3'>{list[0]?.genId}</h6>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-3 col-sm-12 col-xl-3 col-12 ">
                        <h6 className='mt-3  mx-3'> {list[0]?.actionDoer}</h6>
                      </div>
                      <div className="col-md-12 col-lg-2 col-sm-12 col-xl-2 col-12">
                        <h6 className='mt-3  mx-3'> {list[0]?.category}</h6>
                      </div>
                      <div class="col-md-12 col-lg-3 col-sm-12 col-xl-3 col-12">
                        <div className=' mx-3'>
                          <Link
                            data-tooltip-id={`purposeTooltip-${list[0]?.id}`}
                            data-tooltip-content={formatPurpose(list[0]?.purpose)}
                            className="d-inline-block mt-3 d-flex align-items-center text-decoration-none text-dark"
                          >
                            {`${list[0]?.purpose?.slice(0, 25)}...`}
                          </Link>
                          <Tooltip
                            id={`purposeTooltip-${list[0]?.id}`}
                            place="top"
                            effect="solid"
                            delayShow={200}
                            style={{ whiteSpace: 'pre-wrap', backgroundColor: '#01574E' }}

                          />
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-2 col-sm-12 col-xl-2 col-12 d-flex justify-content-start">
                        <h6 className='mt-3 text-xl-end  mx-3'> {getRequestDate(list[0]?.actionDate)}</h6>
                        <Link className="text-dark fs-5 text-decoration-none position-absolute top-0 end-0 bg-dark1 p-2 rounded-2 pb-0 pt-0 mt-2 me-2" onClick={(e) => handleDelete(list[0]?.genId)}>
                          <i className='text-danger fa fa-trash'></i>
                        </Link>
                      </div>
                    </div>

                 
                  </div>
                  {open && index === openIndex && (
                    <div id="example-collapse-text" className="collapse show">
                      <div className="card-body">


                        <div className="table-responsive position-relative" style={{ overflowX: 'auto' }}>
                          <table class="table mb-5 " style={{ minWidth: '800px' }}>
                            <thead className='table-secondary'>
                              <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">Unit</th>
                                <th scope="col">Issue Type</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Total</th>
                                <th scope="col">Create At</th>
                              </tr>
                            </thead>
                            <tbody>
                              {

                                list.map((data, dataIndex) => {

                                  return <>
                                    <tr>
                                      <td>{data.name}</td>
                                      <td>{data.qty}</td>
                                      <td>{data.unit}</td>
                                      <td>
                                        {
                                          data.type === 'ToSupplier' ? (
                                            <span className="rounded-1 pb-1 py-1 px-3 bg-info  text-center text-white  text-capitalize">
                                              {data.type.replace(/([A-Z])/g, ' $1').trim()}
                                            </span>
                                          ) : data.type === 'ToStock' ? (
                                            <span className="rounded-1 pb-1 py-1 px-3 bg-primary  text-center text-white  text-capitalize">
                                              {data.type.replace(/([A-Z])/g, ' $1').trim()}
                                            </span>
                                          ) : (
                                            <span className="rounded-1 pb-1 py-1 px-3 bg-success  text-center text-white  text-capitalize">
                                              {data.type.replace(/([A-Z])/g, ' $1').trim()}
                                            </span>
                                          )
                                        }
                                      </td>
                                      <td>{`$${(+data.amount || 0).toFixed(2)}`}</td>
                                      <td>{`$${(Math.round((data.total || 0) * 100) / 100).toFixed(2)}`}</td>
                                      <td>{data.actionDate}</td>
                                    </tr>

                                  </>
                                })
                              }
                              <tr>
                                <td colSpan="5" className="text-right"><strong>General Total</strong></td>
                                <td><strong>{`$${list.reduce((sum, item) => sum + item.total, 0).toFixed(2)}`}</strong></td>
                                <td colSpan="2"></td> {/* Adding empty cells to align with columns */}
                              </tr>
                            </tbody>
                          </table>


                        </div>



                      </div>
                    </div>
                  )}
                </div>
              })
            }
          </div>

          {
            currentItems.length ? <div className='mt-4'>
              <ul className="pagination justify-content-end">

                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link">{currentPage}</span>
                </li>
                <li className={`page-item ${currentItems.length < itemsPerPage ? 'disabled' : ''} ${currentItems.length === filteredData.length ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                </li>
                <li className="page-item mx-2">
                  <select className="form-select p-0 px-5 py-1 rounded-0" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="40">40</option>
                    <option value="50">50</option>
                  </select>
                </li>
              </ul>
            </div> : <></>
          }
        </div>
      </div>
    </>

  )
}
